export default __webpack_public_path__ + "static/media/no-applicants.0159ed23.svg";